import React, {Component} from 'react';
import {FormattedMessage} from 'react-intl';
import {withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import * as tracking from '../../tracking';
import Util from '../../forecast-app/shared/util/util';
import LogoutMutation from '../../mutations/logout_mutation';

class NoPermission extends Component {
	handleLogout() {
		const onSuccess = ({login}) => {
			tracking.logout();
			window.location.href = window.location.origin;
		};

		Util.CommitMutation(LogoutMutation, null, onSuccess);
	}

	render() {
		const {admins} = this.props;
		return (
			<div className="fullscreen fullscreen-centered-outer trial-end-v2">
				<div className="fullscreen-centered-inner">
					<div className="trial-end-wrapper">
						<div className="trial-end-card large no-permission">
							<img src={require('../../images/logo-v2.svg')} alt="My work" onClick={() => this.props.history.push('/')} />
							<div className="company-details-v2" data-cy={'company-details'}>
								<h3 className="no-top-margin">{<FormattedMessage id="no_permission.contact_admin" />}</h3>
							</div>
							<table>
								{admins.map(admin => {
									const {fullName, email} = admin.node;
									return (
										<tr>
											<td>{fullName}</td>
											<td>
												<a href={`mailto:${email}`}>{email}</a>
											</td>
										</tr>
									);
								})}
							</table>
							<div className="logout-button" onClick={this.handleLogout.bind(this)}>
								<FormattedMessage id="header.log-out" />
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

NoPermission.propTypes = {
	viewer: PropTypes.object.isRequired,
	admins: PropTypes.arrayOf(
		PropTypes.shape({
			fullName: PropTypes.string,
			email: PropTypes.string,
		})
	),
};

export default withRouter(NoPermission);
